// Home.js
import React, { useState, useEffect } from 'react';
import IndexHome1  from './IndexHome1'
import IndexHome2 from './IndexHome2'
// import IndexHome5 from './IndexHome5'
import IndexHome6 from './IndexHome6'
import IndexHome7 from './IndexHome7'

import CommPlaque2 from './CommPlaque2'
import ExploreSlider from './components/HomeRevamp/ExploreSlider'
import Articles from './components/HomeRevamp/Articles'
import StartNowCard from './components/StartNowCard'
import { AnimatedSection } from './components/animation/animateElement'
import { ArrowUp } from 'lucide-react';
import { GetCookie, RemoveCookie } from '../core/utils/cookies';


const Home = () => {
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollToTop(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if(GetCookie('openclaw') === '1') {
      RemoveCookie('openclaw');
    }
  })

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {showScrollToTop && (
        <button 
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-10 h-10 bg-[#3A4F66] hover:bg-blue-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
          aria-label="Scroll to top"
        >
          <ArrowUp className="w-4 h-4" />
        </button>
      )}
      <img
        src="/themes/basilisk/dots.png"
        alt="Flow Background"
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full opacity-60 pointer-events-none select-none"
        style={{ zIndex: 0 }}
      />
      <div className="pt-0 overflow-hidden font-inter">
        <IndexHome1/>
        <AnimatedSection delay={0.1}>
          <div className="">
            <IndexHome2/>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.1}>
          <div className="bg-[#F9FCFC]">
            <CommPlaque2/>
          </div>
        </AnimatedSection>
        
        <AnimatedSection delay={0.1}>
          <ExploreSlider/>
        </AnimatedSection>
        
        {/* tetsimonial section */}
        <AnimatedSection delay={0.1}>
          <IndexHome6/>
        </AnimatedSection>
        
        <AnimatedSection delay={0.1}>
          <Articles/>
        </AnimatedSection>

        <AnimatedSection delay={0.1}>
          <IndexHome7/>
        </AnimatedSection>
        
        <AnimatedSection delay={0.1}>
          <StartNowCard/>
        </AnimatedSection>
      </div>
    </>
  );
};

export default Home;
